import styled from 'styled-components'

const getOffset = side => (typeof side === 'number' ? `${side}px` : 'auto')

const Relative = styled.span`
	position: relative;
	top: ${p => getOffset(p.top)};
	right: ${p => getOffset(p.right)};
	bottom: ${p => getOffset(p.bottom)};
	left: ${p => getOffset(p.left)};
`

export default Relative
